/* import __COLOCATED_TEMPLATE__ from './tag.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
import TEMPLATE from "./tag.hbs";
import { setComponentTemplate } from "@ember/component";
export default setComponentTemplate(TEMPLATE, templateOnlyComponent());